(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-pdrn-offer"] && !Shopify.designMode) return;
  try {
    
  // Order bump: enable/disable the bump line-item fields (keeps the no-JS form fallback correct).
  document.querySelectorAll('.pu-offer__bump-toggle').forEach(function(cb){
    function sync(){
      var form = cb.closest('form');
      if(!form){ return; }
      form.querySelectorAll('[data-bump-field]').forEach(function(f){ f.disabled = !cb.checked; });
    }
    cb.addEventListener('change', sync);
    sync();
  });

  // AJAX add-to-cart. Cart-drawer apps (UpCart, etc.) detect the /cart/add.js fetch and
  // open the drawer automatically. The native <form> POST stays as a no-JS fallback only.
  (function(){
    function collectItems(form){
      var byIndex = [];
      form.querySelectorAll('input[name^="items["]').forEach(function(input){
        if(input.disabled){ return; }
        var m = input.name.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if(!m){ return; }
        var i = parseInt(m[1], 10);
        byIndex[i] = byIndex[i] || {};
        byIndex[i][m[2]] = (m[2] === 'quantity') ? parseInt(input.value || '1', 10) : input.value;
      });
      return byIndex.filter(function(it){ return it && it.id; });
    }

    function addToCart(form){
      var items = collectItems(form);
      if(!items.length){ form.submit(); return; } // nothing to add -> let native form handle it
      var after = form.getAttribute('data-after-add') || 'stay';
      var btn = form.querySelector('.pu-offer__cta');
      if(btn){ btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){
        if(!r.ok){ return r.text().then(function(t){ throw new Error(t); }); }
        return r.json();
      })
      .then(function(){
        if(after === 'checkout'){ window.location.href = '/checkout'; return; }
        if(after === 'cart'){ window.location.href = '/cart'; return; }
        // after === 'stay': notify the theme / cart-drawer app and let it open the slide cart.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function(){ form.submit(); }) // hard fallback to native add if the fetch fails
      .finally(function(){
        if(btn){ btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
    }

    document.querySelectorAll('.pu-offer__form').forEach(function(form){
      // Neutralize native submit while JS is active so UpCart can't grab the multi-item form.
      var btn = form.querySelector('button[type="submit"]');
      if(btn){ btn.type = 'button'; btn.addEventListener('click', function(){ addToCart(form); }); }
      form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(form); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
